import { BlockWrapper, defineBlock, ChildrenBlock, smartProps, useInspectorControl } from '@smartfire/js-block-engine';
import style from './block.module.scss';
import React from 'react';
import clsx from 'clsx';

const Inspector = React.lazy(() => import('./Inspector'));

const ImageContent = ({ isReversed, image }) => {
    useInspectorControl(Inspector);

    return (
        <BlockWrapper.Div className={clsx(style.block, isReversed && style.reversed)}>
            <ChildrenBlock
                key="children"
                gutenbergEditorConfig={{
                    orientation: 'vertical',
                    allowedBlocks: [
                        'core/heading',
                        'core/paragraph',
                        'smartfire/spacer',
                        'smartfire/button',
                        'smartfire/button-form',
                    ],
                    template: [
                        ['core/heading', {}],
                        ['core/paragraph', {}],
                        ['smartfire/button', {}],
                    ],
                }}
                className={style.content}
            />
            <div className={style.background} style={{ backgroundImage: image ? 'url(' + image.url + ')' : null }} />
        </BlockWrapper.Div>
    );
};

export default defineBlock({
    Block: ImageContent,
    smartProps: {
        image: smartProps.image,
        isReversed: smartProps.bool.withDefault(false),
    },
    setup: {
        title: 'Contenu + Image',
    },
});
